import { createMandatoryContext } from '@change-corgi/core-react/context';

import type { useStartAPetitionState } from './hooks';

type StartAPetitionState = ReturnType<typeof useStartAPetitionState>;

/** @knip-ignore */
export const {
	Context: StartAPetitionPageStateContext,
	Provider: StartAPetitionPageStateContextProvider,
	useContext: useStartAPetitionPageState,
} = createMandatoryContext<StartAPetitionState | undefined, StartAPetitionState>(undefined, {
	name: 'StartAPetitionPageStateContext',
	processProviderProps: (props) => props,
});

/** @knip-ignore */
export type StartAPetitionPageState = ReturnType<typeof useStartAPetitionPageState>;
